export default "__VITE_ASSET__450392ec__"